import * as Sentry from '@sentry/angular';
import { sentryAppState } from './sentry-app-state';

const getSentryFeedbackTranslations = (i18n: (key: string) => string) => ({
  triggerLabel: i18n('sentry.reportDialog.triggerLabel'),
  triggerAriaLabel: i18n('sentry.reportDialog.triggerAriaLabel'),
  formTitle: i18n('sentry.reportDialog.formTitle'),
  submitButtonLabel: i18n('sentry.reportDialog.submitButtonLabel'),
  cancelButtonLabel: i18n('sentry.reportDialog.cancelButtonLabel'),
  confirmButtonLabel: i18n('sentry.reportDialog.confirmButtonLabel'),
  addScreenshotButtonLabel: i18n('sentry.reportDialog.addScreenshotButtonLabel'),
  removeScreenshotButtonLabel: i18n('sentry.reportDialog.removeScreenshotButtonLabel'),
  nameLabel: i18n('sentry.reportDialog.nameLabel'),
  namePlaceholder: i18n('sentry.reportDialog.namePlaceholder'),
  emailLabel: i18n('sentry.reportDialog.emailLabel'),
  emailPlaceholder: i18n('sentry.reportDialog.emailPlaceholder'),
  isRequiredLabel: i18n('sentry.reportDialog.isRequiredLabel'),
  messageLabel: i18n('sentry.reportDialog.messageLabel'),
  messagePlaceholder: i18n('sentry.reportDialog.messagePlaceholder'),
  successMessageText: i18n('sentry.reportDialog.successMessageText'),
  highlightToolText: i18n('sentry.reportDialog.highlightToolText'),
  hideToolText: i18n('sentry.reportDialog.hideToolText'),
  removeHighlightText: i18n('sentry.reportDialog.removeHighlightText'),
});

export const initSentry = (dsn: string, i18n: (key: string) => string, release?: string) => {
  Sentry.init({
    dsn,
    release,
    beforeSend(event) {
      if (!sentryAppState.isSentryEnabled) {
        return null; // drop event
      }
      // Optionally enrich with state
      event.user = { id: sentryAppState.userId };
      return event;
    },
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        // todo: mask sensitive data with custom class and "block" option
      }),
      Sentry.feedbackIntegration({
        ...getSentryFeedbackTranslations(i18n),
        autoInject: false, // Prevents Sentry's default button from rendering
        showEmail: false,
        showName: false,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  });
};
